import PbAjaxBase from "./pbAjaxbase";
import captchaInfoPb from "./protos/captcha-info.pb";
import captchaValidatePB from "./protos/captcha-validate.pb";
import url from "c-url";

const serviceMap = {
    CN: "bj-login",
    US: "us-login",
    EUROPE: "europe-login",
    IN: "in-login",
};
const service = serviceMap[url.query("region")] || "account";
function fetchCaptchaInfo(params) {
    return PbAjaxBase(
        {
            service,
            api: "/email/register/picverify/get",
        },
        params,
        captchaInfoPb.Email.RegisterPicVerifyGet
    );
}

function validateCaptcha(params) {
    return PbAjaxBase(
        {
            service,
            api: "/email/register/picverify/check",
        },
        params,
        captchaValidatePB.Email.RegisterPicVerifyCheck
    );
}

export default {
    fetchCaptchaInfo,
    validateCaptcha,
};



// WEBPACK FOOTER //
// ./js/services/captcha-verify.service.js